export var FolderOperationDropdownOption;
(function (FolderOperationDropdownOption) {
    FolderOperationDropdownOption["SHARE"] = "share";
    FolderOperationDropdownOption["RENAME"] = "rename";
    FolderOperationDropdownOption["MOVE"] = "move";
    FolderOperationDropdownOption["DELETE"] = "delete";
})(FolderOperationDropdownOption || (FolderOperationDropdownOption = {}));
